import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import Icon from '@xo-union/tk-component-icons';
import GdsInvitation from '~/glm/models/gds/gds-invitation-model';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import OutsideClickHandler from '@xo-union/component-outside-click';
import MealDropdown from '~/glm/components/guest-list/cells/meal-dropdown.jsx';
import AnalyticsStore from '~/glm/models/analytics-store';
import CustomQuestion from '~/glm/models/gds/gds-custom-question-model';
import dropdownStyles from './dropdown.scss';
import styles from './meal-cell.scss';

@observer
class MealCell extends Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    invitation: PropTypes.instanceOf(GdsInvitation).isRequired,
    trackMeal: PropTypes.func.isRequired,
    mealQuestion: PropTypes.instanceOf(CustomQuestion).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore),
    disabled: PropTypes.bool,
  };

  constructor(props, context) {
    super(props, context);
    this.state = { isEditing: false };
    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  handleClick(meal) {
    const { mealQuestion } = this.props;

    if (!mealQuestion.options.length) return null;

    const { invitation, trackMeal, analyticsStore } = this.props;
    const { answers } = invitation;
    const mealAnswer = answers.find(answer => answer.questionId === mealQuestion.id);

    analyticsStore.track('Dashboard Interaction', {
      action: 'update meal',
      decisionArea: 'body',
      meal: meal && meal.text !== null ? meal.text : 'No Reply',
    });

    const promises = [];
    if (meal && meal.text !== null) {
      const answer = {
        questionId: mealQuestion.id,
        optionId: meal.id,
      };

      if (!mealAnswer) {
        invitation.addAnswer(answer);
      } else if (mealAnswer.optionId !== meal.id) {
        invitation.updateAnswer(mealQuestion.id, answer);
      }
    } else if (meal && meal.text === null && mealAnswer) {
      invitation.removeAnswer(mealQuestion.id);
    }

    const updatedAnswers = invitation.answers.length ? invitation.answers.peek() : [];
    promises.push(invitation.patch({ answers: updatedAnswers }));

    promises.push(trackMeal(true));
    this.setState({ isEditing: false });
    return Promise.all(promises);
  }

  handleOutsideClick() {
    this.setState({ isEditing: false });
  }

  renderOptions = () => {
    const { mealQuestion } = this.props;

    return <MealDropdown showCheckmark borders={true} meals={mealQuestion.options} onClick={this.handleClick} />;
  };

  getMealQuestion = () => {
    const { invitation, mealQuestion } = this.props;

    if (!mealQuestion) return null;
    const mealAnswer = invitation.answers.find(answer => answer.questionId === mealQuestion.id);

    if (!mealAnswer) return 'No Reply';
    const chosenMeal = mealQuestion.options.find(option => option.id === mealAnswer.optionId);

    return chosenMeal ? chosenMeal.text : 'No Reply';
  };

  render() {
    const { disabled = false } = this.props;
    const mealName = this.getMealQuestion();

    return (
      <OutsideClickHandler onOutsideClick={() => this.setState({ isEditing: false })}>
        <td className={styles.meal}>
          <div
            className={classnames('btn-group drop-down', { open: this.state.isEditing }, dropdownStyles.dropdown)}
            onClick={() => this.setState({ isEditing: !this.state.isEditing })}
          >
            <input
              disabled
              className={classnames(styles.mealStatusLabel, {
                [styles.noChosenMealLabel]: mealName === 'No Reply',
                [styles.disabled]: disabled,
              })}
              value={mealName}
            />
            <Icon className={dropdownStyles.rsvpArrow} name={'caret_down'} size="sm" />
            {this.state.isEditing && (
              <ul className={dropdownStyles.menu} role="menu">
                {disabled ? null : this.renderOptions()}
              </ul>
            )}
          </div>
        </td>
      </OutsideClickHandler>
    );
  }
}

export default MealCell;
